<template>
  <div class="ticket_frame">
    	<button type="button" class="button ml-3" @click="openTicket">	<i class="fa fa-external-link fa-ninja fa-ninja-white"></i> Open Ticket</button>
  </div>
</template>
<script>
export default {
  props:{
    provider_name:{
      required: true
    },
    provider_last_name:{
      required: true
    },
    provider_phone:{
      required: true
    },
    provider_country_code:{
      required: true
    },
    provider_email:{
      required: true
    }
  },
  data: function(){
    return{
    }
  },
  computed:{
    getUser(){
      return this.$store.getters.getUser
    },
    getUserView(){
      return this.$store.getters.getUser.view
    }


  },
  methods:{
    openTicket(){
      let user_name = this.getUser.name
      let user_email = this.getUser.email
      let org_name = ''
      if(this.getUserView == 'organization'){
        org_name = this.getUser.organization
      }
      let link_ = `https://share.hsforms.com/1uBxuFoXwQ9Wr4PcfkjMHDgbu4rx?&work_email=${this.provider_email}&are_you_a_caregiver_or_employer_=Employer&email=${user_email}&firstname=${this.provider_name}&lastname=${this.provider_last_name}&first_name=${this.provider_name}&last_name=${this.provider_last_name}&company_name=${org_name}&phone=${this.provider_country_code+this.provider_phone}&TICKET.hs_ticket_priority=HIGH&name_of_contact=${user_name}`
      console.log(link_);
      window.open(link_, '_blank').focus();
    }

  }
}
</script>
<style>
.ticket_frame{
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/HubSpotTicket.vue